export const Url = "https://bookonnileapi.bookonnile.com";
// export const Url = "https://bookonnileapi.bookonnile.com";

// export const NodeUrl = "http://localhost:5001";
export const NodeUrl = "http://localhost:5001";

